/* import __COLOCATED_TEMPLATE__ from './start-over-node.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();